/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CalendarDtoFromJSON, CalendarDtoToJSON, } from './';
export function GroupedCalendarDtoFromJSON(json) {
    return GroupedCalendarDtoFromJSONTyped(json, false);
}
export function GroupedCalendarDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'plateNumber': !exists(json, 'plateNumber') ? undefined : json['plateNumber'],
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'calendarItems': !exists(json, 'calendarItems') ? undefined : (json['calendarItems'] === null ? null : json['calendarItems'].map(CalendarDtoFromJSON)),
    };
}
export function GroupedCalendarDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'plateNumber': value.plateNumber,
        'carId': value.carId,
        'calendarItems': value.calendarItems === undefined ? undefined : (value.calendarItems === null ? null : value.calendarItems.map(CalendarDtoToJSON)),
    };
}
